import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';
import { api } from '../lib/api';
import { useAuth } from '../lib/store';

export default function Login() {
  const [f, setF] = useState({ identifier: '', password: '' });
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const loc = useLocation();
  const setToken = useAuth(s => s.setToken);

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post('/auth/login', f);
      await setToken(data.token);
      toast.success(`Welcome back, ${data.user.display_name || data.user.username}!`);
      nav(loc.state?.from || '/feed', { replace: true });
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  }

  return (
    <AuthLayout title="Welcome back" sub="Log in to continue your journey">
      <div className="grid gap-2">
        <a href="/api/auth/google" className="btn-ghost w-full py-3">
          <GoogleIcon /> Continue with Google
        </a>
        <a href="/api/auth/linkedin" className="btn-ghost w-full py-3">
          <LinkedInIcon /> Continue with LinkedIn
        </a>
      </div>
      <div className="flex items-center gap-3 my-5">
        <div className="h-px bg-ink-200 flex-1" />
        <span className="text-xs font-bold text-ink-400">OR</span>
        <div className="h-px bg-ink-200 flex-1" />
      </div>
      <form onSubmit={submit} className="space-y-3">
        <div>
          <label className="label">Email or username</label>
          <input className="input" value={f.identifier} autoComplete="username"
            onChange={e => setF({ ...f, identifier: e.target.value })} required />
        </div>
        <div>
          <label className="label">Password</label>
          <input className="input" type="password" value={f.password} autoComplete="current-password"
            onChange={e => setF({ ...f, password: e.target.value })} required />
        </div>
        <button className="btn-primary w-full py-3" disabled={busy}>
          {busy ? 'Logging in…' : 'Log in'}
        </button>
      </form>
      <p className="text-center text-sm text-ink-500 mt-5">
        No account? <Link to="/join" className="font-bold text-brand-600">Join free</Link>
      </p>
    </AuthLayout>
  );
}

export function AuthLayout({ title, sub, children, wide }) {
  return (
    <div className="min-h-screen bg-gradient-to-b from-brand-50 via-white to-ink-50 flex items-start sm:items-center justify-center p-3 sm:p-4 py-6">
      <div className={`w-full ${wide ? 'max-w-md' : 'max-w-sm'}`}>
        <Link to="/" className="flex items-center justify-center gap-2 mb-5">
          <div className="w-10 h-10 rounded-2xl grad-brand grid place-items-center text-white">
			<a href="https://wof.im"><img src="/uploads/logo-wof.webp" alt="Wall of Freedom"/></a>
          </div>
          <span className="font-display font-extrabold text-lg">
            Wall of <span className="grad-text">Freedom</span>
          </span>
        </Link>
        <div className="card p-5 sm:p-6">
          <h1 className="font-display text-xl sm:text-2xl font-extrabold">{title}</h1>
          <p className="text-sm text-ink-500 mb-4">{sub}</p>
          {children}
        </div>
      </div>
    </div>
  );
}

export function GoogleIcon() {
  return (<svg width="18" height="18" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z"/><path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1a11 11 0 0 0-9.82 6.06l3.66 2.84C6.71 7.3 9.14 5.38 12 5.38z"/></svg>);
}
export function LinkedInIcon() {
  return (<svg width="18" height="18" viewBox="0 0 24 24" fill="#0A66C2"><path d="M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.34V9h3.42v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 1 1 0-4.13 2.06 2.06 0 0 1 0 4.13zM7.12 20.45H3.55V9h3.57v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.72v20.56C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.72V1.72C24 .77 23.2 0 22.22 0z"/></svg>);
}